var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.04 26.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #cccccb;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.99,25.09c.2-1.36-.23-3.36-1.68-4.13s-2.99-.21-4.28.65l-3.04-5.11c1.28-.5,2.84-1.81,2.77-3.44s-1.31-2.69-2.7-3.38l2.99-5.26c1.08.85,3.01,1.49,4.39.61s1.68-2.48,1.57-4.03h6.02c-.2,1.35.23,3.35,1.68,4.12s2.99.21,4.28-.65l3.04,5.11c-1.28.5-2.84,1.81-2.77,3.44s1.31,2.69,2.7,3.38l-3,5.22c-1.08-.85-3.03-1.48-4.41-.61s-1.68,2.48-1.57,4.03l-5.98.05h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 13.02,
    cy: 13.05,
    r: 3.99
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.b5f874b1af704e1ec99fd97132564a70.svg";
export { ForwardRef as ReactComponent };